/**
 * @generated SignedSource<<dca74fb13edae70af5f87c83ae0f4c01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuestionControls_deleteQuestion_Mutation$variables = {
  id: string;
};
export type QuestionControls_deleteQuestion_Mutation$data = {
  readonly deleteQuestion: {
    readonly form: {
      readonly id: string;
      readonly questions: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  } | null;
};
export type QuestionControls_deleteQuestion_Mutation = {
  response: QuestionControls_deleteQuestion_Mutation$data;
  variables: QuestionControls_deleteQuestion_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "FormsDeleteQuestionMutationPayload",
    "kind": "LinkedField",
    "name": "deleteQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Form",
        "kind": "LinkedField",
        "name": "form",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FormQuestion",
            "kind": "LinkedField",
            "name": "questions",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuestionControls_deleteQuestion_Mutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuestionControls_deleteQuestion_Mutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8a02ea3040ff5b681941c45179b8d37e",
    "id": null,
    "metadata": {},
    "name": "QuestionControls_deleteQuestion_Mutation",
    "operationKind": "mutation",
    "text": "mutation QuestionControls_deleteQuestion_Mutation(\n  $id: ID!\n) {\n  deleteQuestion(input: {id: $id}) {\n    form {\n      id\n      questions {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fdd2d6adbea678d7eab2dbe2dd99374";

export default node;
